import template from './index.html'
import controller from './controller'

export const vsName = 'machineCommissionMain'
export const vsNgType = 'directive'

machinesCommissionSealMain.$inject = []
export function machinesCommissionSealMain() {
  return {
    restrict: 'E',
    controller: controller,
    templateUrl: template,
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      machineId: '='
    }
  }
}
